<script>
import ProductCompareButton from '@/components/containers/plp/ProductCard/ProductCompareButton';
import {mapActions, mapGetters, mapState} from 'vuex';
import find from 'lodash/find';

export default {
  components: {ProductCompareButton},
  props: {
    product: {
      type: Object,
      default() {
        return {
          productName: '',
          imageUrl: '',
          productCode: '',
          productUrl: '',
        };
      },
    },
    imageUrl: {
      type: String,
      default: '',
    },
    productCode: {
      type: String,
      default: '',
    },
    productName: {
      type: String,
      default: '',
    },
    productUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      hover: false,
      flashAdded: false,
      flashRemoved: false,
      flashTime: 1000,
    };
  },

  computed: {
    computedProduct() {
      return {
        name: this.productName,
        imageURLList: [this.imageUrl],
        code: this.productCode,
        url: this.productUrl,
      };
    },

    ...mapGetters(['unitId']),
    ...mapState('compare', ['racks']),

    compareIcon() {
      if (this.flashAdded) {
        return 'add_circle';
      } else if (this.flashRemoved) {
        return 'remove_circle';
      } else if (this.hover && this.isRackFull()) {
        return this.inRack() ? 'remove_circle_outline' : 'remove_circle';
      } else {
        return this.inRack() ? 'remove_circle_outline' : 'add_circle_outline';
      }
    },

    compareText() {
      if (this.flashAdded) {
        return this.bp('added');
      } else if (this.flashRemoved) {
        return this.bp('removed');
      } else if (this.hover && this.isRackFull()) {
        return this.inRack() ? this.bp('remove') : this.bp('cannotAdd');
      } else {
        return this.inRack() ? this.bp('remove') : this.bp('compare');
      }
    },
  },

  methods: {
    ...mapActions('compare', ['addToRack', 'removeFromRack']),

    isRackFull() {
      if (this.racks && this.racks[this.unitId]) return this.racks[this.unitId].length === 4;
    },

    inRack() {
      if (this.racks && this.racks[this.unitId]) return find(this.racks[this.unitId], {productCode: this.productCode});
    },

    compareIconColor() {
      if (this.flashAdded) {
        return 'text-green';
      } else if (this.flashRemoved) {
        return 'text-red';
      } else if (this.inRack()) {
        return 'text-red';
      }
    },

    onCompareClick() {
      const product = {
        productName: this.productName,
        imageUrl: this.imageUrl,
        productCode: this.productCode,
        productUrl: this.productUrl,
      };

      if (this.inRack()) {
        this.flashRemoved = true;
        setTimeout(() => {
          this.flashRemoved = false;
        }, this.flashTime);
        return this.removeFromRack(product);
      }

      if (!this.isRackFull()) {
        this.flashAdded = true;
        setTimeout(() => {
          this.flashAdded = false;
        }, this.flashTime);
        return this.addToRack(product);
      } else {
        this.$notify({
          dangerouslyUseHTMLString: true,
          type: 'alert',
          message: this.bp('cannotAdd'),
        });
      }
    },
  },
};
</script>
